import {
  getScreenData,
  saveScreeningFeedback,
} from "../panelLogin/api-client.js";
import { getCustomerFields } from "../../utils/apiFunctions.js";
import { required, minValue, numeric, between } from "vuelidate/lib/validators";
import toast from "../../components/mixin/toast.js";
export default {
  mixins: [toast],
  data() {
    return {
      currentPage: 1,
      numPages: 0,
      perPage: 1,
      screeningID: this.$route.params.id,
      screenData: {
        submitted: false,
        candidate: {
          resume: null,
        },
      },
      showAdvanced: false,
      selectedJD: {},
      normalFields: [],
      advancedFields: [],
      feedback: {
        recommendation: "",
        recommendationComments: "",
        skills: [],
      },
      loaderStatus: true,
    };
  },
  validations() {
    return {
      feedback: {
        recommendation: { required },
        recommendationComments: { required },
        skills: {
          required,
          $each: {
            name: { required },
            mark: {
              required,
              minValue: minValue(1),
              numeric,
              between: between(1, 5),
            },
            comments: { required },
          },
        },
      },
    };
  },
  created() {
    this.getScreenData();
    this.getCustomFields();
  },
  methods: {
    downloadLink(link) {
      const a = document.createElement("a");
      a.href = link;
      a.click();
    },
    goBack() {
      this.$router.push({
        path: "/panellogin?status=screening",
      });
    },
    goBackMobile() {
      this.$router.push({
        name: "mobresumeScreening",
      });
    },
    async submitFeedback() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.loaderStatus = true;
      try {
        const payload = {
          id: this.screeningID,
          feedback: this.feedback,
        };
        console.log(payload, "thi is the payload");

        const response = await saveScreeningFeedback(payload);
        if (response.status === 200) {
          this.successModal("Feedback submitted successfully");
          this.goBack();
        } else {
          this.errorModal(response.data.data.Detail);
        }
      } catch (error) {
        console.log(error);
        this.errorModal("Something went wrong");
      } finally {
        this.loaderStatus = false;
      }
    },
    async getScreenData() {
      try {
        const response = await getScreenData({ id: this.screeningID });
        if (response.status === 200) {
          this.screenData = response.data.data;
          if (this.screenData.submitted) {
            this.feedback = this.screenData.feedback;
          }
          this.selectedJD = this.screenData.jobData;
        } else {
          this.errorModal(response.data.data.Detail);
        }
      } catch (error) {
        console.error("Error fetching screen data:", error);
        this.errorModal("Error fetching screen data");
      } finally {
        this.loaderStatus = false;
      }
    },
    async getCustomFields() {
      try {
        let payload = {
          parentID: "1",
        };
        const res = await getCustomerFields(payload);
        if (res.status == 200) {
          const customFields = res.data.data.fields;
          for (const field of customFields) {
            if (field.category === 1) {
              this.normalFields.push(field);
            } else {
              this.advancedFields.push(field);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
